export default __webpack_public_path__ + "static/media/B2.fb7719fd.jpg";